"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DpToggle = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("react");
var classnames_1 = __importDefault(require("classnames"));
var DpToggle_styled_1 = require("./DpToggle.styled");
var accessibility_helper_1 = require("../../../api/helpers/accessibility.helper");
var DpToggle = function (_a) {
    var _b = _a.isActive, isActive = _b === void 0 ? true : _b, labelText = _a.labelText, ariaLabel = _a.ariaLabel, toggleHandler = _a.toggleHandler, _c = _a.className, className = _c === void 0 ? '' : _c, _d = _a.variant, variant = _d === void 0 ? 'light' : _d;
    var _e = (0, react_1.useState)(isActive), isToggleOn = _e[0], toggleState = _e[1];
    var toggle = function () {
        var newValue = !isToggleOn;
        toggleState(newValue);
        if (toggleHandler) {
            toggleHandler(newValue);
        }
    };
    (0, react_1.useEffect)(function () {
        toggleState(isActive);
    }, [isActive]);
    var toggleClasses = (0, classnames_1.default)('rounded-pill', className);
    var handleEnter = function (e) {
        var target = e === null || e === void 0 ? void 0 : e.target;
        target.click();
    };
    return ((0, jsx_runtime_1.jsxs)(DpToggle_styled_1.StyledToggle, { variant: variant, className: "switch-toggle", children: [labelText && (0, jsx_runtime_1.jsx)("span", { children: labelText }), (0, jsx_runtime_1.jsxs)("label", { className: "toggle", children: [(0, jsx_runtime_1.jsx)("input", { type: "checkbox", className: "switch", "aria-checked": isToggleOn, "aria-label": ariaLabel || '', checked: isToggleOn, onChange: toggle, onKeyDown: (0, accessibility_helper_1.handleButtonPress)(handleEnter), role: "switch" }), (0, jsx_runtime_1.jsx)("div", { className: toggleClasses, children: (0, jsx_runtime_1.jsx)("div", {}) })] })] }));
};
exports.DpToggle = DpToggle;
exports.default = exports.DpToggle;
